import React from "react";
import { useQuery } from "react-query";
import { getDynamicData } from "../../../../../actions/Utilities/CustomReport";

const useGetDynamicData = (selectedReport: string) => {
  return useQuery(["GetDynamicData"], () => getDynamicData(selectedReport), {
    refetchOnWindowFocus: false,
  });
};

export default useGetDynamicData;
